import { cloneDeep } from 'lodash';

import { initialState as initialTargetingState } from 'containers/TargetingPeeqPage/constants';
import { fetchTargetingSuccessActionHandler } from 'containers/TargetingPeeqPage/reducer_utils';

class PeeqTargetingAPI {
  // using a private member here
  // to avoid accidental external mutations
  #state;

  constructor(fetchedTargeting = {}) {
    const initializedState = fetchTargetingSuccessActionHandler(
      initialTargetingState,
      fetchedTargeting,
    );

    this.#state = initializedState;
  }

  addScreeningQuestion() {
    // placeholder
  }

  removeAllScreeningQuestion() {
    // placeholder
  }

  updateScreeningQuestion() {
    // placeholder
  }

  get state() {
    return cloneDeep(this.#state);
  }
}

export default PeeqTargetingAPI;
